import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/metrics',
)({
  // Observability surface, as the cluster metrics tab.
  staticData: {
    domain: 'monitoring',
  },
  component: lazyRouteComponent(() => import('@/components/Serverless/SpaceMetrics/SpaceMetrics'), 'SpaceMetrics'),
});
